//ProtectedRoutes.js

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Box, CircularProgress } from '@mui/material';

const adminOnlyRoutes = [
  '/utilisateurs',
  '/listedeclarations',
  '/facturepage'
];

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, role } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const currentRole = (role || '').toUpperCase();
  const currentPath = decodeURIComponent(location.pathname).toLowerCase();

  const isAdminOnlyRoute = adminOnlyRoutes.some(
    (route) => currentPath === route || currentPath.startsWith(route + '/')
  );

  if (isAdminOnlyRoute && currentRole !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
